export default {
  namespaced: true,
  actions: {
    destroy({ commit }, id) {
      this.$authorize('edit', 'Profile')

      return Vue.$http.delete(`admin/financial_surveys/${id}`)
    }
  },
}
